import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import IssueDetails from "./features/Issues/IssueDetails";
import Issues from "./features/Issues/Issues";
import Access from "./features/Maintenance/Access";
import EditServiceEntry from "./features/ServiceEntry/EditServiceEntry";
import ServiceEntry from "./features/ServiceEntry/ServiceEntry";
import Services from "./features/ServiceEntry/Services";
import WordOrderDetails from "./features/WorkOrders/WordOrderDetails";
import WorkOrders from "./features/WorkOrders/WorkOrders";
import MainLayout from "./layouts/mainLayout";
import DataDashboard from "./pages/DataDashboard";
import DefaultPassword from "./pages/DefaultPassword";
import ForgotPassword from "./pages/ForgotPassword";
import Login from "./pages/Login";
import Maintenance from "./pages/Maintenance";
import NotFound from "./pages/NotFound";
import ResetPassword from "./pages/ResetPassword";
import Settings from "./pages/Settings";
import Tyre from "./pages/Tyre";
import { store } from "./store";
import ProtectedRoute from "./utils/ProtectedRoutes";
import { SocketProvider } from "./utils/SocketContext";

const App = () => {
  return (
    <SocketProvider>
      <Provider store={store}>
        <BrowserRouter>
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />

          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/change-default-password" element={<DefaultPassword />} />
            <Route path="/no-access" element={<NotFound />} />

            <Route
              path="/settings"
              element={
                <ProtectedRoute permission="any">
                  <MainLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Settings />} />
            </Route>

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute permission="any">
                  <MainLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DataDashboard />} />
            </Route>

            <Route
              path="/services"
              element={
                <ProtectedRoute permission="any">
                  <MainLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Services />} />
            </Route>

            <Route
              path="/services/service-entry"
              element={
                // <ProtectedRoute permission="create">
                <MainLayout />
                // </ProtectedRoute>
              }
            >
              <Route index element={<ServiceEntry />} />
            </Route>

            <Route
              path="/services/edit-service-entry/:id"
              element={
                // <ProtectedRoute permission="edit">
                <MainLayout />
                // </ProtectedRoute>
              }
            >
              <Route index element={<EditServiceEntry />} />
            </Route>

            <Route
              path="/work-orders"
              element={
                <ProtectedRoute permission="any">
                  <MainLayout />
                </ProtectedRoute>
              }>
              <Route index element={<WorkOrders />} />
            </Route>

            <Route
              path="/work-orders/work-order-details/:id"
              element={
                // <ProtectedRoute permission="any">
                <MainLayout />
                // </ProtectedRoute>
              }>
              <Route index element={<WordOrderDetails />} />
            </Route>

            <Route
              path="/issue"
              element={
                <ProtectedRoute permission="any">
                  <MainLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Issues />} />
            </Route>

            <Route
              path="/issue/issue-details/:id"
              element={
                // <ProtectedRoute permission="any">
                <MainLayout />
                // </ProtectedRoute>
              }
            >
              <Route index element={<IssueDetails />} />
            </Route>

            <Route
              path="/access-management"
              element={
                <ProtectedRoute permission="view">
                  <MainLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Access />} />
            </Route>

            <Route
              path="/maintenance"
              element={
                <ProtectedRoute permission="view">
                  <MainLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Maintenance />} />
            </Route>

            <Route
              path="/tyre"
              element={
                <ProtectedRoute permission="view">
                  <MainLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Tyre />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </Provider>
    </SocketProvider>
  );
};

export default App;
